module.exports={
    zh:{
        searchForm:{
             gardenName:'园所名称',
             state:'状态',
             all:'全部',
             ban:'禁用',
             active:'启用',
             search:'查询',
             reset:'重置'
        },
        manageTable:{
            gardenName:'园所名称',
            englishName:'英文名称',
            state:'状态',
            operate:'操作',
            add:'添加',
            edit:'编辑',
            info:'园所信息'
        },
        manageDialog:{
          title:"园所信息",
          gardenName:"上级园所名称",
          name:"园所名称",
          englishName:"园所英文名称",
          code:"园所代码",
          save:"保存",
          cancel:"取消"


        },
       gardenInfo:{
        gardenName:'园所名称',
        info:"基本信息",
        edit:"编辑",
        englishName:"园所英文名称",
        code:"园所代码",
        address:"所在区域",
        postcode:"邮政编码",
        manager:"负责人",
        tel:"联系电话",
        fax:"传真",
        email:"邮箱",
        language:"默认语言",
        introduce:"园区介绍",
        save:"保存",
        cancel:"取消" 
       },
       attachmenttable:{
          manage:"附件管理",
          uploadFile:"上传附件",
          number:"序号",
           type:"类型",
           name:"附件名称",
           operate:"操作",
           upload:"上传",
           fileType:"附件类型",
           save:"确定",
           cancel:"取消" ,
           look:"查看",
           download:"下载",
           delete:"删除"

       },
       calendar:{
           student:'学生校历',
           staff:"职工校历"
       },
       addEvent:{
           addfestival:"添加节日",
           dayEidt:"添加工作日与非工作日",
           day:"工作日",
           selectionDate:'选择日期',
           start:"开始日期",
           end:"结束日期",
           name:"名称",
           dayOff:'是否休息',
           mark:"备注",
           cancel:"取消",
           delete:"删除",
           save:"保存",
           textOne:"是",
           textTwo:'否',
           leftReason:'离园原因',
           heighClass:'升班',
           nowClass:'现班级',
           newClass:'新班级',
           confirm:'确认',
        
       },
    setClass:{
        gardenName:'园所名称',
        add:'添加',
        ban:'禁用',
        active:'启用',
        number:"序号",
        name:"班级名称",
        volume:"容量",
        state:"状态",
        operate:"操作",
        edit:"编辑",
        delete:"删除",
        addClass:"添加班级",
        capacity:"班级容量",
        mark:"备注",
        save:"保存",
        cancel:"取消",
        editClass:"编辑班级"
        
    }


    },
    en:{
        searchForm:{
            gardenName:'School',
            state:'Status',
            all:'All',
            ban:'Inactive',
            active:'Active',
            search:'Search',
            reset:'Reset'
       },
       manageTable:{
        gardenName:'School',
        englishName:'School English Name',
        state:'Status',
        operate:'Action',
         add:'Add',
         edit:'Edit',
         info:'Info'
    },
    manageDialog:{
        title:"Kindergarten Info",
        gardenName:"Higher School",
        name:"School ",
        englishName:"School English Name",
        code:"School Code",
        save:'save',
        cancel:'cancel'

      },
      gardenInfo:{
        gardenName:'School Name',
        info:"School Information ",
        edit:"Edit",
        englishName:"Shool English Name",
        code:"School Code",
        address:"Address ",
        postcode:"Postcode",
        manager:"Owner",
        tel:"Tel",
        fax:"传真",
        email:"Fax",
        language:"Chinese",
        introduce:"School Introduce",
        save:'save',
        cancel:'cancel'
       },
       attachmenttable:{
        type:"Type",
        name:"Name",
        number:"No",
        operate:"Action",
        upload:"Upload",
        fileType:"Type",
        manage:"Attachment Manage",
        uploadFile:"Upload Attachment",
        save:"Confirm",
        cancel:"Cancel" ,
        look:"Check",
        download:"Download",
        delete:"Delete"
    },
    calendar:{
        student:'Public Version',
        staff:"School Version"
    },
    addEvent:{
        addfestival:"Add/Eidt Event",
        dayEidt:"Add Days Or days Off",
        day:"Days",
        selectionDate:'Selection date',
        start:"Start",
        end:"End",
        name:"Event Name",
        dayOff:'school Closed',
        mark:"Note",
        cancel:"Cancel",
        delete:"Delete",
        save:"Save",
        textOne:'Yes',
        textTwo:'No',
        leftReason:'leftReason',
        heighClass:'heighClass',
        nowClass:'nowClass',
        newClass:'newClass',
        confirm:'confirm',
    },
    setClass:{
        gardenName:'School',
        add:'Add',
        ban:'Inactive',
        active:'Active',
        number:"No",
        name:"Class",
        volume:"Qualitity of Children",
        state:"Status",
        operate:"Action",
        edit:"Eidt",
        delete:"Delete",
        addClass:"Add Class",
        capacity:"Qty of Children",
        mark:"Note",
        save:"Save",
        cancel:"Cancel",
        editClass:"editClass"
        
    } 
      
    }
}


// WEBPACK FOOTER //
// ./src/components/i18n/lang/gardenManage.js